module.exports = __webpack_public_path__ + "img/renci.9996e65d.png";